<template>
  <button
    @click="toggleAccordion()"
    class="text-zinc-800 relative z-[2] dark:text-zinc-500  hover:bg-zinc-200 dark:hover:bg-zinc-700 w-full flex text-left box-border p-3"
    :aria-expanded="isOpen"
    :aria-controls="`collapse${_uid}`"
    :class="{
      'bg-zinc-200  dark:bg-zinc-700': isOpen,
      'bg-transparent': !isOpen,
    }"
  >
    <span class="mr-3 text-2xl">
      <slot name="icon"></slot>
    </span>
    <span class="w-full">
      <slot name="title" />
    </span>
    <span
      class="box-border mt-1 text-zinc-500 dark:text-zinc-500"
      :class="{
        'rotate-180': isOpen,
        'rotate-0': !isOpen,
      }"
    >
      <span class="float-right">
        <Icon icon="fa6-solid:angle-down" />
      </span>
    </span>
  </button>

  <transition name="slide-down">
    <div
      class="dark:bg-zinc-900 relative z-[1] bg-zinc-300 mt-2 p-2"
      v-show="isOpen"
      :id="`collapse${_uid}`"
    >
      <slot name="content" />
    </div>
  </transition>
</template>

<script>
import { Icon } from "@iconify/vue";
export default {
  data() {
    return {
      isOpen: false,
    };
  },

  methods: {
    toggleAccordion() {
      this.isOpen = !this.isOpen;
    },
  },
  components: {
    Icon,
  },
};
</script>
